<template>
  <form @submit.prevent="handleSubmit">
    <div class="bg-gray-50 rounded-lg p-4">
      <div class="relative">
        <textarea
          v-model="query"
          rows="3"
          class="w-full bg-white border-2 border-gray-300 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-orange-500 focus:border-orange-500 resize-none pr-24 shadow-sm"
          placeholder="Ask a question about your practices, engagements, action items, or blockers..."
          :disabled="loading"
        ></textarea>
        <div class="absolute bottom-3 right-3 flex items-center gap-2">
          <span
            v-if="query.length > 0"
            class="text-xs"
            :class="query.length > 1000 ? 'text-red-500' : 'text-gray-400'"
          >
            {{ query.length }} / 1,000
          </span>
          <button
            type="submit"
            :disabled="!canSubmit || loading"
            class="px-4 py-1.5 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5 shadow-sm"
          >
            <svg v-if="loading" class="animate-spin h-3.5 w-3.5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ loading ? 'Submitting...' : 'Ask' }}
          </button>
        </div>
      </div>

      <!-- Suggestions -->
      <div v-if="!query" class="mt-3 space-y-3">
        <!-- Questions / Analysis -->
        <div>
          <p class="text-xs font-medium text-gray-500 mb-1.5">Questions / Analysis</p>
          <div class="flex flex-wrap gap-1.5">
            <button
              v-for="example in examples"
              :key="example"
              type="button"
              class="px-2.5 py-1 text-xs bg-white hover:bg-blue-50 border border-blue-200 rounded-full text-blue-700 transition-colors"
              :disabled="loading"
              @click="query = example"
            >
              {{ example }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'AnalystQueryForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  data() {
    return {
      query: '',
      examples: [
        'Write a summary report of all open blockers and overdue action items, grouped by practice and owner',
        'Create an engagement activity briefing for the last 30 days highlighting which practices need immediate attention',
        'Analyze engagement trends this quarter and summarize which practices are progressing vs stalling',
        'Build a readiness report showing each practice\'s outstanding items, recent engagement frequency, and recommended next steps',
      ],
    }
  },
  computed: {
    canSubmit() {
      return this.query.trim().length > 0 && this.query.length <= 1000
    },
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit) return

      this.$emit('submit', {
        query: this.query.trim(),
      })

      this.query = ''
    },

    appendQuery(text) {
      this.query = this.query ? this.query + '\n' + text : text
    },
  },
}
</script>
